const style = (theme) => ({
  paper: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2.5, 4, 4),
  },
  resendOTP: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  linkOTP: {
    textDecoration: 'none',
  },
  inputText: {
    fontSize: 18,
    letterSpacing: 10,
    textAlign: 'center',
    fontWeight: 'bold',
  },
})

export default style
